import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import RenderField from '../../FormTemplate/InputControl';
import SelectAsync from '../../FormTemplate/SelectAsync';
import Select from '../../FormTemplate/Select';
import RenderTextArea from '../../FormTemplate/TextareaControl';
import { Button } from 'react-bootstrap';

class NewProductMainForm extends React.Component {
   render() {
      const { handleSubmit, submitting, pristine, invalid, saveMainProduct, has_sub_items } = this.props;
      return (
         <form noValidate autoComplete="off" onSubmit={handleSubmit(saveMainProduct)} >

            <label ><Field name="has_sub_items" component="input" type="checkbox" /> Check this if this item contain
               sub-items</label >

            <hr />
            <h3 >Items General Information</h3 >
            <hr />
            <Field name="name" component={RenderField} type="text" label="Product Name" />
            {!has_sub_items &&
            <Field name="barcode" component={RenderField} type="text" label="Barcode" />}
            <Field name="description" component={RenderTextArea} rows="7" label="Product Description" />
            <Field name="price" component={RenderField} type="number" label="Price" />
            <Field name="discount" component={RenderField} type="number" label="Discount" />
            <Field name="brand_id" component={SelectAsync} link="brands/searchByName" label="Brand Name" />
            <Field name="made_in_country_id" component={SelectAsync} link="countries/searchByName"
                   label="Made In Country" />
            <Field name="net_weight" component={RenderField} type="number" label="Net Weight (gm)" />
            <Field name="active" component={Select}
                   options={[{ value: 1, label: "Active" }, { value: 0, label: "In Active" }]}
                   label="Active / InActive" />
            <Button type="submit" bsStyle="success" block disabled={submitting || pristine || invalid} >Save</Button >
         </form >
      );
   }
}

NewProductMainForm.propTypes = {
   handleSubmit: PropTypes.func,
   saveMainProduct: PropTypes.func.isRequired,
   submitting: PropTypes.boolean,
   has_sub_items: PropTypes.boolean,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
};

NewProductMainForm = reduxForm({ //eslint-disable-line
   form: 'itemNewProductMainForm',
   initialValues: {
      active: 1,
   }
})(NewProductMainForm);

const selector = formValueSelector('itemNewProductMainForm');

NewProductMainForm = connect(state => { // eslint-disable-line
   const has_sub_items = selector(state, 'has_sub_items');
   return {
      has_sub_items,
   };
})(NewProductMainForm);

export default NewProductMainForm;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/NewProductMainForm.js
 **/